module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daymodsnow-80fa4808d7041a2211ad5ffc18c636c8.webp";